import { defineComponent as _defineComponent } from 'vue'
import InstagramInstantwinPrizeMain from '@/client/features/instagram_instantwin_prize/components/InstagramInstantwinPrizeMain.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramInstantwinPrize',
  setup(__props) {


return { __sfc: true,InstagramInstantwinPrizeMain }
}

})